import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles<Theme>((theme) => ({
  containerButton: {
    marginTop: theme.spacing(4),
  },
  input: {
    width: "50%",
  },
  title: {
    fontSize: "18px",
    fontWeight: 700,
    marginBottom: "17px",
    lineHeight: "21px",
  },
  label: {
    fontSize: "12px",
  },
}));

export default useStyles;
